import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noHtmlMarkup'
})
export class NoHtmlMarkup implements PipeTransform {
  transform(value: string): string {
    return value.replace(/<\/?[^>]+(>|$)/g, ' ');
  }
}
